export function modbusDeviceViewStandaloneSearch(search: string): boolean {
  const q = new URLSearchParams(search);
  return Boolean(String(q.get("id") || "").trim());
}
/** ``/modbus-device-view/public/<token>`` is served by the API (password gate HTML), not the React router — bounce to configured API origin when the UI is hosted on ``klt-iot.com`` with static SPA fallback (avoids Shell "page not found"). */
